import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '../axiosBaseQuery';

import { EnvelopeResult } from './../store';

export interface FeatureResponse {
  Name: string;
  IsEnabled: boolean;
}

export interface Feature {
  name: string;
  isEnabled: boolean;
}

export interface CustomSystemDate {
  currentDate : string;
}

export const featuresApi = createApi({
  reducerPath: 'featuresApi',
  baseQuery: axiosBaseQuery({ baseUrl: '/web-api' }),
  endpoints: (builder) => ({
    getFeatures: builder.query<Feature[], void>({
      query: () => ({ url: `/b2c/api/features`, method: 'get' }),
      transformResponse: (features: FeatureResponse[]) =>
        features.map((feature) => ({
          name: feature.Name,
          isEnabled: feature.IsEnabled,
        })),
    }),
    getSystemDate: builder.query<string, void>({
      query: () => ({ url: `/api/config/date`, method: 'get' }),
      transformResponse: (response: CustomSystemDate) => response.currentDate,
    }),
    setDate: builder.mutation<string, string>({
      query: (date) => ({
        url: '/b2c/api/systemtime/set',
        method: 'POST',
        data: { Date: date }, //TODO[GP - future fix] fix typo on API side
      }),
      transformResponse: (response: EnvelopeResult<CustomSystemDate>) => response.Data.currentDate,
    }),
    resetDate: builder.mutation<string, void>({
      query: () => ({
        url: '/b2c/api/systemtime/reset',
        method: 'GET',
      }),
      transformResponse: (response: EnvelopeResult<CustomSystemDate>) => response.Data.currentDate,
    }),
    getIsEiiEnabled: builder.query<boolean, number | string>({
      query: (countryId) => ({ url: `/api/basedata/isEiiEnabled/${countryId}`, method: 'get' }),
      transformResponse: (response: { Value: boolean }) => response.Value,
    }),
  }),
});

export const {
  useGetFeaturesQuery,
  useLazyGetSystemDateQuery,
  useSetDateMutation,
  useResetDateMutation,
  useGetIsEiiEnabledQuery,
} = featuresApi;
